const fontFamily = {
  base: '"IBM Plex Sans", sans-serif',
  baseBold: '"IBM Plex Sans Bold", sans-serif',
  display: '"LF Rubrik", "Times New Roman", serif',
};

export const fontWeight = {
  regular: 400,
  semiBold: 600,
  bold: 700,
};

const type = {
  exLargeTitle: {
    default: {
      fontWeight: fontWeight.regular,
      fontFamily: fontFamily.display,
      fontSize: '32px',
      lineHeight: '40px',
      breakpoints: [
        {
          breakpointSize: 'md',
          fontSize: '48px',
          lineHeight: '58px',
        },
      ],
    },
  },
  h1: {
    default: {
      fontWeight: fontWeight.regular,
      fontFamily: fontFamily.display,
      fontSize: '24px',
      lineHeight: '32px',
      breakpoints: [
        {
          breakpointSize: 'md',
          fontSize: '32px',
          lineHeight: '40px',
        },
      ],
    },
  },
  h2: {
    default: {
      fontWeight: fontWeight.bold,
      fontFamily: fontFamily.baseBold,
      fontSize: '24px',
      lineHeight: '28px',
        letterSpacing: '-0.05em',
    },
  },
  h3: {
    default: {
      fontWeight: fontWeight.bold,
      fontFamily: fontFamily.baseBold,
      fontSize: '20px',
      lineHeight: '24px',
        letterSpacing: '-0.05em',
    },
  },
  h4: {
    default: {
      fontWeight: fontWeight.bold,
      fontFamily: fontFamily.baseBold,
      fontSize: '16px',
      lineHeight: '20px',
        letterSpacing: '-0.05em',
    },
  },
  bodyLarge: {
    default: {
      fontWeight: fontWeight.regular,
      fontFamily: fontFamily.base,
      fontSize: '20px',
      lineHeight: '28px',
        letterSpacing: '-0.05em',
      breakpoints: [
        {
          breakpointSize: 'md',
          fontSize: '24px',
          lineHeight: '32px',
            letterSpacing: '-0.05em',
        },
      ],
    },
  },
  paragraphBold: {
    default: {
      fontWeight: fontWeight.bold,
      fontFamily: fontFamily.baseBold,
      fontSize: '16px',
      lineHeight: '20px',
        letterSpacing: '-0.05em',
    },
  },
  paragraph: {
    default: {
      fontWeight: fontWeight.regular,
      fontFamily: fontFamily.base,
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: '-0.05em',
    },
  },
  fieldLabel: {
    default: {
      fontWeight: fontWeight.bold,
      fontFamily: fontFamily.baseBold,
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: '-0.05em',
    },
  },
  fieldPrompt: {
    default: {
      fontWeight: fontWeight.regular,
      fontFamily: fontFamily.base,
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: '-0.05em',
    },
  },
  fieldInput: {
    default: {
      fontWeight: fontWeight.regular,
      fontFamily: fontFamily.base,
      fontSize: '16px',
      lineHeight: '22px',
      letterSpacing: '-0.05em',
    },
  },
  labelRegular: {
    default: {
      fontWeight: fontWeight.regular,
      fontFamily: fontFamily.base,
      fontSize: '14px',
      lineHeight: '18px',
      letterSpacing: '-0.05em',
    },
  },
  labelSemiBold: {
    default: {
      fontWeight: fontWeight.semiBold,
      fontFamily: fontFamily.baseBold,
      fontSize: '14px',
      lineHeight: '18px',
      letterSpacing: '-0.05em',
    },
  },
  small: {
    default: {
      fontWeight: fontWeight.regular,
      fontFamily: fontFamily.base,
      fontSize: '14px',
      lineHeight: '16px',
      letterSpacing: '-0.05em',
    },
  },
  smallBold: {
    default: {
      fontWeight: fontWeight.bold,
      fontFamily: fontFamily.baseBold,
      fontSize: '14px',
      lineHeight: '16px',
      letterSpacing: '-0.05em',
    },
  },
  a: {
    default: {
      fontWeight: fontWeight.bold,
      fontFamily: fontFamily.baseBold,
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: '-0.05em',
    },
  },
  largePrice: {
    default: {
      fontWeight: fontWeight.regular,
      fontFamily: fontFamily.display,
      fontSize: '38px',
      lineHeight: '38px',
      breakpoints: [
        {
          breakpointSize: 'md',
          fontSize: '48px',
          lineHeight: '48px',
        },
      ],
    },
  },
};

export default type;
export type ThemeFonts = typeof type;
export type ThemeFontsKeys = keyof typeof type;
